import React from 'react';

function BenefitsOfHelp({ onRequestAssistance }) {
    return (
        <section className="information" id="benefits-of-help">
            <div className="content">
                <h2>Benefits of Getting Help</h2>
                <p>
                    Navigating the <span className="osap-highlight">OSAP</span> application process can be overwhelming, but getting professional help can make all the difference.
                </p>
                <ul>
                    <li><strong>Higher approval chances:</strong> Experts ensure your application is complete and accurate, increasing the likelihood of approval.</li>
                    <li><strong>Faster processing:</strong> Avoid delays by submitting a well-prepared application the first time.</li>
                    <li><strong>Stress-free experience:</strong> Let professionals handle the details, so you can focus on your studies.</li>
                </ul>
                <p>
                    Don’t risk your funding—<a href="#" onClick={onRequestAssistance}>request assistance</a> today and secure the support you need with confidence.
                </p>
            </div>
        </section>
    );
}

export default BenefitsOfHelp;